import React, { useContext, useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { Box, CircularProgress, Link, Stack, Typography, useTheme } from '@mui/material'
import ToggleInput from '../../../../components/form/ToggleInput'
import { POSTES_NAMES, SIMULATEUR_TYPE_RESULT, SIMULATOR_FIELD } from '../services/simulatorConstants'
import { mdiCurrencyEur, mdiEarHearing, mdiGlasses, mdiHospitalBuilding, mdiInformation, mdiInformationOutline, mdiStethoscope, mdiToothOutline } from '@mdi/js'
import SelectInput from '../../../../components/form/SelectInput'
import { FormattedMessage, useIntl } from 'react-intl'
import Icon from '@mdi/react'
import ButtonDefault from '../../../../components/ButtonDefault'
import TextInput from '../../../../components/form/TextInput'
import { simulate } from '../../../../api/gerep/Simulateur'
import LocalStorage from '../../../../business/storage/LocalStorage'
import { ToastContext } from '../../../../components/toast/ToastContext'
import { ToastType } from '../../../../components/toast/toastConstants'
import SimulationChart from './SimulationChart'
import { useBreakpoints } from '../../../../components/breakpoints/BreakpointsProvider'
import ReactGA from 'react-ga'
import { SIMULATEUR_GA_ACTION, SIMULATEUR_GA_CATEGORY } from '../../../../utils/servicesUtils'
import { replaceEntityLinks } from '../../../../utils/FormatUtils'
import GuideGestionErrorPopin from './GuideGestionErrorPopin'
import { cardiboxActions, cardiboxSelectors } from 'redux-cardibox'
import { getContratBaseSante } from '../../../webservices/contrats/contratsSelector'
import * as contratsActions from '../../../webservices/contrats/contratsActions'
import { compose } from 'redux'
import { connect } from 'react-redux'
import appConst from '../../../../constant/appConstants'
import { userSelector } from '../../user/userSelectors'
import { getServiceProfil } from '../../../webservices/servicesSante/servicesSanteSelectors'
import { getServiceProfil as loadServicesProfil } from '../../../webservices/servicesSante/servicesSanteActions'

type SimulationFormProps = {
	matrix?: any
	user: any
}

const MAX_DEPENSE = 10000

const ARTICLE_INTRO_SHORTCUT = 'simulateur_sante_introduction'
const ARTICLE_SANTE_SHORTCUT = 'simulateur_sante_100_bloc'

const POSTES_DATA: SelectOption[] = [
	{
		value: POSTES_NAMES.SOINS_COURANTS,
		label: POSTES_NAMES.SOINS_COURANTS,
		icon: mdiStethoscope
	},
	{
		value: POSTES_NAMES.DENTAIRE,
		label: POSTES_NAMES.DENTAIRE,
		icon: mdiToothOutline
	},
	{
		value: POSTES_NAMES.OPTIQUE,
		label: POSTES_NAMES.OPTIQUE,
		icon: mdiGlasses
	},
	{
		value: POSTES_NAMES.AIDES_AUDITIVES,
		label: POSTES_NAMES.AIDES_AUDITIVES,
		icon: mdiEarHearing
	},
	{
		value: POSTES_NAMES.HOSPITALISATION,
		label: POSTES_NAMES.HOSPITALISATION,
		icon: mdiHospitalBuilding
	}
]

const SimulationForm: React.FC<SimulationFormProps> = (
	{
		// @ts-ignore
		articleIntro,
		// @ts-ignore
		sante100Content,
		// @ts-ignore
		getArticle,
		// @ts-ignore
		company,
		// @ts-ignore
		loadContrats,
		// @ts-ignore
		download,
		// @ts-ignore
		loadServicesProfil,
		// @ts-ignore
		service,
		matrix,
		user
	}
) => {
	const intl = useIntl()
	const theme = useTheme()
	const { addToast } = useContext(ToastContext)
	const { isMobile } = useBreakpoints()

	const [simulationData, setSimulationData] = useState<any>()
	const [simulationData100sante, setSimulationData100sante] = useState<any>()
	const [simulationDataRmbLimit, setSimulationDataRmbLimit] = useState<any>()
	const [oneSimulation, setOneSimulation] = useState<boolean>(true)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [openGestionError, setOpenGestionError] = useState<boolean>(false)

	useEffect(() => {
		getArticle(appConst.cardiboxApi, ARTICLE_INTRO_SHORTCUT)
		getArticle(appConst.cardiboxApi, ARTICLE_SANTE_SHORTCUT)
		loadContrats()
		loadServicesProfil()
	}, [getArticle, loadContrats, loadServicesProfil])

	const getDataResult = () => {
		const listResult: SelectOption[] = []
		if(simulationData100sante) {
			listResult.push({
				label: intl.formatMessage({ id: 'simulation.result.subtitle100Sante' }),
				value: SIMULATEUR_TYPE_RESULT.SANTE_100,
				color: "#8AC11D",
				colorSecondary: '#232323'
			})
		}
		if(simulationDataRmbLimit){
			listResult.push({
				label: intl.formatMessage({ id: 'simulation.result.subtitleRmbLimit' }),
				value: SIMULATEUR_TYPE_RESULT.LIMITE,
				color: undefined
			})
		}
		if(simulationData) {
			listResult.push({
				label: intl.formatMessage({ id: 'simulation.result.subtitleLibre' }),
				value: SIMULATEUR_TYPE_RESULT.LIBRE,
				color: undefined
			})
		}
		return listResult
	}

	const downloadContrat = (numgar: any, siret: any) => {
		download(numgar, siret)
			.catch(() => {
				setOpenGestionError(true)
			})
	}
	const onSubmit = (values: any) => {
		const {
			amount,
			poste,
			typeActe,
			sousTypeActe
		} = values

		ReactGA.event({
			category: SIMULATEUR_GA_CATEGORY,
			action: SIMULATEUR_GA_ACTION,
			label: 'Calcul',
			value: Number(amount)
		})
		let selectedOption: any
		if(matrix[poste][typeActe].length === 1){
			selectedOption = matrix[poste][typeActe][0]
		} else {
			selectedOption = matrix[poste][typeActe].find((option: any) => option.sousTypeActe === sousTypeActe)
		}

		const cleanedDepense = amount && amount.replace(',', '.')
		setIsLoading(true)
		return simulate(LocalStorage.getToken(), {
			idSimulation: selectedOption.id,
			depense: cleanedDepense
		})
			.then(simulation => {
				var has100Sante = false
				simulation.forEach((data: any) => {
					var dataReformat = {
							depense: cleanedDepense,
							hypotheses: data.matrixLine.texteAval,
							sousTypeActe,
							txss: data.matrixLine.txss,
							brss: data.matrixLine.brss,
							franchise: data.matrixLine.franchise,
							garantie: data.matrixLine.garantie,
							mtLimite: data.matrixLine.mtLimite,
							rembSs: data.rembSs,
							rembGerep: data.rembGerep,
							resteACharge: data.resteACharge,
						}
					if(data.matrixLine.typePanier === SIMULATEUR_TYPE_RESULT.LIBRE){
						if(simulation.length === 1){
							values[SIMULATOR_FIELD.TYPE_RESULT] = SIMULATEUR_TYPE_RESULT.LIBRE
						}
						setSimulationData(dataReformat)
					} else if(data.matrixLine.typePanier === SIMULATEUR_TYPE_RESULT.LIMITE){
						if(simulation.length === 1){
							values[SIMULATOR_FIELD.TYPE_RESULT] = SIMULATEUR_TYPE_RESULT.LIMITE
						}
						setSimulationDataRmbLimit(dataReformat)
					} else if(data.matrixLine.typePanier === SIMULATEUR_TYPE_RESULT.SANTE_100){
						if(simulation.length === 1){
							values[SIMULATOR_FIELD.TYPE_RESULT] = SIMULATEUR_TYPE_RESULT.SANTE_100
						}
						has100Sante= true
						setSimulationData100sante(dataReformat)
					}
				})
				if(simulation.length > 1){
					setOneSimulation(false)
					if(has100Sante){
						values[SIMULATOR_FIELD.TYPE_RESULT] = SIMULATEUR_TYPE_RESULT.SANTE_100
					} else {
						values[SIMULATOR_FIELD.TYPE_RESULT] = SIMULATEUR_TYPE_RESULT.LIBRE
					}
				} else {
					setOneSimulation(true)
				}
			})
			.catch(() => addToast(ToastType.ERROR, 'global.error.occurred'))
			.finally(() => setIsLoading(false))
	}

	return (
		<>
			<Form
				onSubmit={onSubmit}
				validate={(values: any) => {
					const errors: any = {}
					if (!values[SIMULATOR_FIELD.AMOUNT]) {
						errors[SIMULATOR_FIELD.AMOUNT] = intl.formatMessage({ id: 'global.error.required' })
					} else if (parseFloat(values[SIMULATOR_FIELD.AMOUNT]) <= 0 || parseFloat(values[SIMULATOR_FIELD.AMOUNT]) > MAX_DEPENSE) {
						errors[SIMULATOR_FIELD.AMOUNT] = intl.formatMessage({ id: 'global.error.format' })
					}
					return errors
				}}
				render={({ handleSubmit, values, form: { reset } }) => {

					const resetForm = () => {
						setSimulationData(undefined)
						setSimulationData100sante(undefined)
						setSimulationDataRmbLimit(undefined)
					}


					return (
						<form onSubmit={handleSubmit}>
							{!(simulationData || simulationData100sante || simulationDataRmbLimit) &&
								<Stack direction="column" spacing="12px">
									<Typography variant="body2">
										{
											articleIntro && (
												<Box
													dangerouslySetInnerHTML={{ __html: (articleIntro.fields && replaceEntityLinks(articleIntro.fields.body)) }}
													sx={{ 'a': { color: '#e96e11' } }}
												/>
											)
										}
									</Typography>
									{company &&
										<Typography variant="body2">
											<FormattedMessage
												id="simulation.guide"
												values={{
													guide: (
														<Link onClick={() => downloadContrat(company.numgar, company.siret)} href="#" color={theme.palette.secondary.main}>
															guide de gestion
														</Link>
													)
												}}
											/>
										</Typography>
									}
									<Stack direction="column" spacing="24px">
										<Box display="flex" flex={1}>
											{!isMobile ?
												<ToggleInput
													label={
														<Typography variant="body2">
															<FormattedMessage id="simulation.label.poste" />
														</Typography>
													}
													name={SIMULATOR_FIELD.POSTE}
													data={POSTES_DATA}
													onChange={(e) => {
														ReactGA.event({
															category: SIMULATEUR_GA_CATEGORY,
															action: SIMULATEUR_GA_ACTION,
															label: e.replace(' ', '-')
														})
														reset()
														setSimulationData(undefined)
														setSimulationData100sante(undefined)
														setSimulationDataRmbLimit(undefined)
													}}
												/> :
												<SelectInput
													label={<FormattedMessage id="simulation.label.posteMobile" />}
													name={SIMULATOR_FIELD.POSTE}
													data={POSTES_DATA}
													onChange={(e) => {
														ReactGA.event({
															category: SIMULATEUR_GA_CATEGORY,
															action: SIMULATEUR_GA_ACTION,
															label: e.replace(' ', '-')
														})
														reset()
														setSimulationData(undefined)
														setSimulationData100sante(undefined)
														setSimulationDataRmbLimit(undefined)
													}}
												/>
											}
										</Box>
										{values[SIMULATOR_FIELD.POSTE] && (
											<Stack direction="column" spacing="12px">
												<SelectInput
													label={intl.formatMessage({ id: 'simulation.label.typeSoin' })}
													name={SIMULATOR_FIELD.TYPE_ACTE}
													data={Object.keys(matrix[values[SIMULATOR_FIELD.POSTE]]).map((key: string) => ({
														value: key,
														label: key
													}))}
													onChange={() => {
														values[SIMULATOR_FIELD.SOUS_TYPE_ACTE] = undefined
														values[SIMULATOR_FIELD.AMOUNT] = undefined
													}}
												/>
												{values[SIMULATOR_FIELD.TYPE_ACTE] &&
													matrix[values[SIMULATOR_FIELD.POSTE]] &&
													matrix[values[SIMULATOR_FIELD.POSTE]][values[SIMULATOR_FIELD.TYPE_ACTE]] &&
													<Stack direction="row" spacing="8px">
														<Box width="20px" height="20px">
															<Icon path={mdiInformationOutline} size="20px" color="#232323" />
														</Box>
														<Typography variant="body2">
															{matrix[values[SIMULATOR_FIELD.POSTE]][values[SIMULATOR_FIELD.TYPE_ACTE]][0]?.texteAmontNiveau2 || ''}
														</Typography>
													</Stack>
												}
											</Stack>
										)}
										{values[SIMULATOR_FIELD.TYPE_ACTE] && matrix[values[SIMULATOR_FIELD.POSTE]][values[SIMULATOR_FIELD.TYPE_ACTE]].filter((item: any) => item.sousTypeActe !== null).length > 0 && (
											<Stack direction="column" spacing="12px">
												<SelectInput
													label={intl.formatMessage({ id: 'simulation.label.sousTypeSoin' })}
													name={SIMULATOR_FIELD.SOUS_TYPE_ACTE}
													data={matrix[values[SIMULATOR_FIELD.POSTE]][values[SIMULATOR_FIELD.TYPE_ACTE]].map((item: any) => ({
														value: item.sousTypeActe,
														label: item.sousTypeActe
													}))}
												/>
												{values[SIMULATOR_FIELD.SOUS_TYPE_ACTE] && matrix[values[SIMULATOR_FIELD.POSTE]][values[SIMULATOR_FIELD.TYPE_ACTE]].find((item: any) => item.sousTypeActe === values[SIMULATOR_FIELD.SOUS_TYPE_ACTE])?.texteAmontNiveau3 &&
													<Stack direction="row" spacing="8px">
														<Box width="20px" height="20px">
															<Icon path={mdiInformationOutline} size="20px" color="#232323" />
														</Box>
														<Typography variant="body2">
															{matrix[values[SIMULATOR_FIELD.POSTE]][values[SIMULATOR_FIELD.TYPE_ACTE]].find((item: any) => item.sousTypeActe === values[SIMULATOR_FIELD.SOUS_TYPE_ACTE])?.texteAmontNiveau3 || ''}
														</Typography>
													</Stack>
												}
											</Stack>
										)}
										{(values[SIMULATOR_FIELD.SOUS_TYPE_ACTE] || (values[SIMULATOR_FIELD.TYPE_ACTE] && matrix[values[SIMULATOR_FIELD.POSTE]][values[SIMULATOR_FIELD.TYPE_ACTE]].filter((item: any) => item.sousTypeActe !== null).length == 0 )) && (
											<Stack direction="column" spacing="24px">
												<Box display="flex" justifyContent="center">
													<TextInput
														numberOnly
														name={SIMULATOR_FIELD.AMOUNT}
														label={intl.formatMessage({ id: 'simulation.label.amount' })}
														rightIcon={<Icon path={mdiCurrencyEur} size="20px" color="#606060" />}
														style={{ textAlign: 'end', paddingRight: '8px' }}
													/>
												</Box>
												{(values[SIMULATOR_FIELD.TYPE_ACTE]
													&& values[SIMULATOR_FIELD.AMOUNT]
													&& (values[SIMULATOR_FIELD.SOUS_TYPE_ACTE]
														|| (!values[SIMULATOR_FIELD.SOUS_TYPE_ACTE] && values[SIMULATOR_FIELD.TYPE_ACTE] && matrix[values[SIMULATOR_FIELD.POSTE]][values[SIMULATOR_FIELD.TYPE_ACTE]].filter((item: any) => item.sousTypeActe !== null).length == 0 )) ) && (
													<Box display="flex" justifyContent="center">
														<ButtonDefault variant="contained" type="submit" onClick={handleSubmit}>
															{isLoading ? <CircularProgress size={24} color="inherit" /> : <FormattedMessage id="simulation.button.calculate" />}
														</ButtonDefault>
													</Box>
												)}
											</Stack>
										)}
									</Stack>
								</Stack>
							}
							{ (simulationData || simulationData100sante || simulationDataRmbLimit) &&
								<Stack direction="column" spacing="12px">
									<Stack direction="row" spacing="12px" display="flex" >
										<Stack direction="column" spacing="12px" textAlign="left" width="100%">
											<Typography textAlign="left" variant="h2">
												{intl.formatMessage({ id: 'simulation.result.title' }).toUpperCase()}
											</Typography>
											<Typography textAlign="left" variant="subtitle1">
												<FormattedMessage id="simulation.result.cost" values={{ amount: parseFloat(values[SIMULATOR_FIELD.AMOUNT]).toFixed(2).replace('.', ',') }}/> - {values[SIMULATOR_FIELD.SOUS_TYPE_ACTE]? values[SIMULATOR_FIELD.SOUS_TYPE_ACTE] : values[SIMULATOR_FIELD.TYPE_ACTE]}
											</Typography>
										</Stack>
										{ !oneSimulation &&
											<Stack direction="column" spacing="12px" textAlign="right">
												<img src={`${window.location.origin}/blobs/medias/s/logo_100_sante/logo_100_Sante.png`} style={{ height: '48px' }} alt="" />
											</Stack>
										}
									</Stack>
									<Stack direction="column" spacing="24px">
										{!oneSimulation && (
											<ToggleInput
												name={SIMULATOR_FIELD.TYPE_RESULT}
												data={getDataResult()}
											/>
										)}
										{ simulationData && values[SIMULATOR_FIELD.TYPE_RESULT] === SIMULATEUR_TYPE_RESULT.LIBRE && (
											<Stack direction="column" spacing="24px">
												<SimulationChart has100Sante={!oneSimulation} sante100Content={sante100Content} service={service} user={user} resetFormAction={resetForm} {...simulationData} />
											</Stack>
										)}
										{ simulationData100sante && values[SIMULATOR_FIELD.TYPE_RESULT] === SIMULATEUR_TYPE_RESULT.SANTE_100 && (
											<Stack direction="column" spacing="24px">
												{ (simulationData100sante.mtLimite && simulationData100sante.mtLimite!== 0 && values[SIMULATOR_FIELD.AMOUNT] > simulationData100sante.mtLimite) && (
													<Stack direction="row" spacing="14px">
														<Icon path={mdiInformation} style={{width: "45px", height: "35px"}} color="#E96E11" />
														<Typography textAlign="left" variant="body2">
															<FormattedMessage id="simulation.result.maxLimite" values={{ amount: parseFloat(simulationData100sante.mtLimite).toFixed(2).replace('.', ',') }} />
														</Typography>
													</Stack>
												)}
												<SimulationChart has100Sante={!oneSimulation} sante100Content={sante100Content} service={service} user={user} resetFormAction={resetForm} {...simulationData100sante} />
											</Stack>
										)}
										{ simulationDataRmbLimit && values[SIMULATOR_FIELD.TYPE_RESULT] === SIMULATEUR_TYPE_RESULT.LIMITE && (
											<Stack direction="column" spacing="24px">
												{ (simulationDataRmbLimit.mtLimite && simulationDataRmbLimit.mtLimite!== 0 && values[SIMULATOR_FIELD.AMOUNT] > simulationDataRmbLimit.mtLimite) && (
													<Stack direction="row" spacing="14px">
														<Icon path={mdiInformation} style={{width: "45px", height: "35px"}} color="#E96E11" />
														<Typography textAlign="left" variant="body2">
															<FormattedMessage id="simulation.result.maxLimite" values={{ amount: parseFloat(simulationDataRmbLimit.mtLimite).toFixed(2).replace('.', ',') }} />
														</Typography>
													</Stack>
												)}
												<SimulationChart has100Sante={!oneSimulation} sante100Content={sante100Content} service={service} user={user} resetFormAction={resetForm} {...simulationDataRmbLimit} />
											</Stack>
										)}
									</Stack>
								</Stack>
							}
						</form>
					)
				}}
				/>
			<GuideGestionErrorPopin open={openGestionError} setOpen={setOpenGestionError} />
		</>
	)
}

const mapStateToProps = (state: any) => ({
	articleIntro: cardiboxSelectors.articles.getByShortcut(state.cardibox)[ARTICLE_INTRO_SHORTCUT],
	sante100Content: cardiboxSelectors.articles.getByShortcut(state.cardibox)[ARTICLE_SANTE_SHORTCUT],
	company: getContratBaseSante(state),
	user: userSelector(state),
	service: getServiceProfil(state)
})

const mappedActions = {
	getArticle: cardiboxActions.articles.getByShortcut,
	loadContrats: contratsActions.loadContrats,
	loadServicesProfil,
	download: contratsActions.download
}

export default compose(
	connect(mapStateToProps, mappedActions)
)(SimulationForm)

